var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    width: 50,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M0,25A25,25,0,1,1,25,50,25,25,0,0,1,0,25",
    fill: "#164295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M34.426,24.388h-.018a.953.953,0,0,0-.937.956v3.092a2.114,2.114,0,0,1-2.084,2.127h-15.9a2.116,2.116,0,0,1-2.089-2.133V25.346a.947.947,0,1,0-1.894,0v3.083a4.022,4.022,0,0,0,3.977,4.045H31.392a4.019,4.019,0,0,0,3.972-4.041V25.349a.954.954,0,0,0-.937-.961",
    transform: "translate(1.568 3.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M27.552,22.294l-.144-.149a.985.985,0,0,0-1.236,0l-2.62,2.245L23.546,13.3a.953.953,0,0,0-.375-.615.936.936,0,0,0-.7-.169.962.962,0,0,0-.791.873v11l-2.62-2.244a.986.986,0,0,0-1.233,0,.851.851,0,0,0-.148,1.186L22,27.053a.974.974,0,0,0,.614.217,1.013,1.013,0,0,0,.635-.226L27.4,23.481a.851.851,0,0,0,.149-1.186",
    transform: "translate(2.386 1.705)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/Group_icon.53fff75b37c0371c528adeaab8c3ce57.svg";
export { ForwardRef as ReactComponent };